import type { SVGProps } from "react";
const SenecPictogramMeetingArea = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10ZM10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34 10C34 7.79086 35.7909 6 38 6C40.2091 6 42 7.79086 42 10C42 12.2091 40.2091 14 38 14C35.7909 14 34 12.2091 34 10ZM38 8C36.8954 8 36 8.89543 36 10C36 11.1046 36.8954 12 38 12C39.1046 12 40 11.1046 40 10C40 8.89543 39.1046 8 38 8Z"
            fill="currentColor"
        />
        <path
            d="M6 19C6 17.3431 7.34315 16 9 16C12.866 16 16 19.134 16 23V30H20V42H18V32H9C7.34315 32 6 30.6569 6 29V28C6 27.4477 6.44772 27 7 27C7.55228 27 8 27.4477 8 28V29C8 29.5523 8.44772 30 9 30H14V23C14 20.2386 11.7614 18 9 18C8.44772 18 8 18.4477 8 19V23C8 23.5523 7.55228 24 7 24C6.44772 24 6 23.5523 6 23V19Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 23C32 19.134 35.134 16 39 16C40.6569 16 42 17.3431 42 19V29C42 30.6569 40.6569 32 39 32H30V42H28V30H32V23ZM34 30H39C39.5523 30 40 29.5523 40 29V19C40 18.4477 39.5523 18 39 18C36.2386 18 34 20.2386 34 23V30Z"
            fill="currentColor"
        />
        <path
            d="M18 25C18 24.4477 18.4477 24 19 24H29C29.5523 24 30 24.4477 30 25C30 25.5523 29.5523 26 29 26H25V42H23V26H19C18.4477 26 18 25.5523 18 25Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramMeetingArea;
